module.exports = __webpack_public_path__ + "static/img/6.a9a38bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/6.png
// module id = EZOi
// module chunks = 0